export default __webpack_public_path__ + "static/undraw-having-fun-ebe5e0242e69b63fd454df83d30a925e.png";